import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export interface SizeGuideProps {
  children?: React.ReactNode;
}

export function SizeGuide({ children }: SizeGuideProps) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.div`
  background-color: ${vars.v3Color.staticWhite};
`;

const Header = styled.div`
  margin-bottom: 28px;
`;

const Title = styled.h3`
  margin-bottom: 16px;
`;

const Subtitle = styled.p`
  color: ${vars.v3Color.gray700};
  line-height: 140%;
`;

const TabBar = styled.ul`
  margin-bottom: 24px;
  display: flex;
  height: 40px;
  background: ${vars.v3Color.gray100};
  border-radius: 8px;
`;

const TabBarItem = styled.li<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px 11px;
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${vars.v3Color.gray300};
  text-align: center;
  border-radius: 8px;
  border: 2px solid ${vars.v3Color.gray100};

  ${({ active }) =>
    active &&
    css`
      color: ${vars.v3Color.gray900};
      background-color: ${vars.v3Color.staticWhite};
    `};
`;

SizeGuide.Header = Header;
SizeGuide.Title = Title;
SizeGuide.Subtitle = Subtitle;
SizeGuide.TabBar = TabBar;
SizeGuide.TabBarItem = TabBarItem;
